import UseCase from "./marketing/UseCase";

export default function UseCaseFounders() {
  return (
    <UseCase
      path="/for/founders"
      seoTitle="NFC business cards for founders — WhoBrew"
      seoDescription="A digital business card for early-stage founders. Press kit, deck, calendar, demo video, and LinkedIn in one link. Replaces the awkward conference card shuffle."
      eyebrow="For founders"
      headline="The card you actually want to hand to an investor."
      italicWord="actually"
      subhead="Press kit, deck, demo loom, calendar, and LinkedIn in one link. Update the deck the night before a meeting and every card you handed out in the last twelve months updates with it."
      preview={{ name: "Sean Thomas", title: "Co-founder & CEO", handle: "seanthomas" }}
      linkExamples={[
        { label: "Press kit" },
        { label: "Pitch deck" },
        { label: "Demo Loom" },
        { label: "Calendar" },
        { label: "LinkedIn" },
        { label: "AngelList / OpenVC" },
        { label: "Crunchbase" },
        { label: "Customer page" },
      ]}
      features={[
        {
          title: "A deck that's always the latest version.",
          body: "Replace the deck file at any time. The card link stays the same. The investor who opens your card three months later still gets the current deck, not the version with the metric you'd rather forget.",
        },
        {
          title: "Press kit that doesn't need a Dropbox link.",
          body: "Logo, headshot, one-paragraph bio, and three quotable lines, all on a single page. Reporters love a press kit that loads in their browser without an account.",
        },
        {
          title: "Calendar that respects your founder time.",
          body: "Single-line Calendly with the meeting types you actually take — investor first call, advisor sync, customer interview. The right slot, not the spray-and-pray inbox negotiation.",
        },
      ]}
      steps={[
        {
          title: "Build a card with your deck, demo, and calendar.",
          body: "Drop in your pitch deck PDF, a 2-minute Loom demo, your investor calendar, and your press kit. Five minutes.",
        },
        {
          title: "Hand it out at every conference, demo day, and intro coffee.",
          body: "Order an NFC card to keep in your wallet. Tap it at YC demo day, every fundraising coffee, every founder dinner. Same card, same link, every time.",
        },
        {
          title: "Update the deck before each meeting.",
          body: "Refresh the metrics, swap the customer logos, or update the team slide the night before each pitch. Every prior share now points to the current version.",
        },
      ]}
      faq={[
        {
          q: "Is a digital card really appropriate for a fundraising context?",
          a: "Yes. Most early-stage investors prefer being handed a single link they can read on the phone over receiving a paper card and remembering to look it up later. The deck, the demo, and the calendar are right there on the same page.",
        },
        {
          q: "Can I track which investors actually opened the deck?",
          a: "WhoBrew Insights show counts and shapes, not identities. If you want per-investor attribution, send the deck via DocSend or similar tools alongside your card. Many founders do exactly this — public card for first impression, gated link for serious interest.",
        },
        {
          q: "What about the press kit — can journalists download files?",
          a: "Yes. Each press-kit asset is a downloadable link from your card. Logo SVG, headshot JPG, bio TXT. Journalists can grab what they need without an account or a slack channel.",
        },
        {
          q: "Should I use this once we're a series A and our team is bigger?",
          a: "Yes. The Teams plan gives the whole company centralized branding and admin controls, so every employee's card stays on-brand without a lift from your designer.",
        },
      ]}
    />
  );
}
